import React from "react";

import { Button } from "ii-ui-kit";

import keyImg from "images/key.png";
import "./index.scss";

/** Ошибка "Неверный код подтверждения "*/
export const IncorrectCodeConfirm = () => {
  return (
    <div className="incorrect-code-confirm">
      <img src={keyImg} alt="" className="incorrect-code-confirm__img" />
      <div className="incorrect-code-confirm__title">
        Неверный код подтверждения
      </div>
      <div className="incorrect-code-confirm__text">
        В целях безопасности вход в личный кабинет будет заблокирован на 10
        минут
      </div>
      <Button
        className="incorrect-code-confirm__button"
        title={"Вернуться на главную "}
        size={"l"}
      />
    </div>
  );
};
